import React from "react";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  IconHome, IconLogout, IconRoute, IconLanguage, IconCompass,
} from "@tabler/icons-react";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";
import { BrandLogo } from "@/components/site/SiteNav";
import TourCoach from "@/components/tour/TourCoach";

export default function AppShell() {
  const { user, logout } = useAuth();
  const { t, toggle, lang } = useI18n();
  const nav = useNavigate();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-tert font-mono text-[11px] tracking-widest uppercase">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;

  const roleLabel = t(`roles.${user.role}`);

  return (
    <div className="min-h-screen bg-paper flex flex-col">
      <header className="glass-bar sticky top-0 z-40 h-14">
        <div className="wrap-app max-w-[1160px] h-full flex items-center justify-between">
          <button className="flex items-center gap-2.5" onClick={() => nav("/app")} data-testid="app-brand">
            <BrandLogo />
            <span className="font-display text-[16px] tracking-tight">Chiessa<span className="text-honey">.</span> Institute</span>
          </button>
          <nav className="hidden md:flex items-center gap-5 text-[12.5px] text-muted">
            <button onClick={() => nav("/app")} className="hover:text-teal-deep" data-testid="app-nav-home">{t("nav.home")}</button>
            <button onClick={() => nav("/nosotros")} className="hover:text-teal-deep" data-testid="app-nav-about">{t("nav.about")}</button>
            <button onClick={() => nav("/psicogadgets")} className="hover:text-teal-deep" data-testid="app-nav-gadgets">{t("nav.gadgets")}</button>
          </nav>
          <div className="flex items-center gap-2">
            <button
              onClick={toggle}
              className="btn-ghost btn text-[11px] px-2 py-1"
              title="Idioma"
              data-testid="app-lang-toggle"
            >
              <IconLanguage size={13} />
              <span className="font-mono tracking-widest">{lang === "es" ? "ES" : "EN"}</span>
            </button>
            <button
              onClick={() => window.dispatchEvent(new Event("chiessa:tour:start"))}
              className="btn-ghost btn text-[11px] px-2 py-1"
              title={lang === "es" ? "Ver tour guiado" : "Guided tour"}
              aria-label={lang === "es" ? "Ver tour guiado" : "Guided tour"}
              data-testid="app-tour-launch"
            >
              <IconCompass size={13} />
            </button>
            <button className="btn-ghost btn text-[11px] px-2 py-1" onClick={() => nav("/")} title={t("nav.home")} data-testid="app-go-home">
              <IconHome size={14} />
            </button>
            <span className="tag" data-testid="app-role-pill">{roleLabel}</span>
            <button
              className="btn-ghost btn text-[11px] px-2 py-1"
              onClick={async () => { await logout(); nav("/"); }}
              title={t("nav.logout")}
              data-testid="app-logout"
            >
              <IconLogout size={14} />
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <TourCoach />
    </div>
  );
}
